// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_iqE","cls2":"FeedbackModal-cls2_M3s FeedbackModal-cls1_iqE"};